(() => {
  const PROMO_BUY = 6;
  const PROMO_PAY = 3;
  const KARPATIAN_UNIT_PRICE = 117;
  const PERIOD_MONTHS = 36;

  const money = (amount) => new Intl.NumberFormat('es-PE', {
    style: 'currency', currency: 'PEN', maximumFractionDigits: 0
  }).format(amount).replace('PEN', 'S/');

  function getKarpatianPrice(units) {
    const promoSets = Math.floor(units / PROMO_BUY);
    const remaining = units % PROMO_BUY;
    const paidUnits = promoSets * PROMO_PAY + remaining;
    return { paidUnits, total: paidUnits * KARPATIAN_UNIT_PRICE };
  }

  document.querySelectorAll('[data-tdf-calculator]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const quantity = Math.floor(Number(form.elements.quantity.value));
      const currentPrice = Number(form.elements.currentPrice.value);
      const lifetime = Number(form.elements.lifetime.value);
      if (!Number.isFinite(quantity) || quantity < 1 || !Number.isFinite(currentPrice) || currentPrice <= 0 || !Number.isFinite(lifetime) || lifetime < 1) return;

      const cycles = Math.ceil(PERIOD_MONTHS / lifetime);
      const currentUnits = quantity * cycles;
      const currentTotal = currentUnits * currentPrice;
      const karpatian = getKarpatianPrice(quantity);
      const results = form.parentElement.querySelector('[data-tdf-results]');
      results.querySelector('[data-tdf-current-total]').textContent = money(currentTotal);
      results.querySelector('[data-tdf-current-units]').textContent = `${currentUnits} cuchillos estimados en ${PERIOD_MONTHS} meses`;
      results.querySelector('[data-tdf-karpatian-total]').textContent = money(karpatian.total);
      results.querySelector('[data-tdf-karpatian-paid]').textContent = `${quantity} cuchillos; pagas ${karpatian.paidUnits} con la promo vigente`;

      const difference = currentTotal - karpatian.total;
const amount = results.querySelector('[data-tdf-difference-amount]');
const message = results.querySelector('[data-tdf-difference]');

if (difference > 0) {
  amount.textContent = money(difference);
  amount.hidden = false;
  message.textContent = 'Ahorro estimado en reposición durante 3 años, según los datos que ingresaste.';
} else if (difference < 0) {
  amount.hidden = true;
  message.textContent = `Con estos datos, el gasto estimado en KARPATIAN sería ${money(Math.abs(difference))} mayor durante esos 3 años.`;
} else {
  amount.hidden = true;
  message.textContent = 'Con estos datos, ambos costos estimados son iguales durante esos 3 años.';
}

      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  document.querySelectorAll('[data-tdf-buy]').forEach((button) => {
    button.addEventListener('click', () => {
      const addButton = document.querySelector('product-form form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[name="add"]');
      if (addButton) {
        addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => addButton.focus({ preventScroll: true }), 450);
      } else {
        document.querySelector('#MainProduct, main')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();